import React from 'react';
import OAuth from '../OAuth';

const Login = () => {
    return (
        <div>
            <OAuth />
        </div>
    );
};

export default Login;